import MapLocationDefinition from "../model/MapLocationDefinition";

export default class OpenMapCharacterMenuEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {MapLocationDefinition} location 
     */
    constructor(type, location) {
        this.type = type;
        this.location = location;
    }
}

OpenMapCharacterMenuEvent.OPEN_MENU_FOR_LOCATION = "OpenMapCharacterMenuEvent.location";